export class MultiWait {
  count: number;
  callback: Function | null;
  waitFn: () => void;

  constructor() {
    this.count = 0;
    this.callback = null;

    this.waitFn = () => {
      this.count--;
      if (this.count === 0 && this.callback) {
        this.callback();
      }
    };
  }

  one() {
    this.count++;
    return this.waitFn;
  }

  wait(callback: Function) {
    if (this.count === 0) {
      if (callback) {
        callback();
      }
    } else {
      this.callback = callback;
    }
  }
}

